"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "UploadUi",
  props: {
    accept: {
      type: String,
      default: ".doc,.docx"
    }
  },
  data: function data() {
    return {
      name: "",
      fileList: [],
      uploadFileUrl: process.env.VUE_APP_BASE_API + "/common/upload",
      ossGenUrl: ""
    };
  },
  methods: {
    uploadSuccess: function uploadSuccess(res, file) {
      this.ossGenUrl = res.ossOriUrl;
      this.$emit("successData", file, this.ossGenUrl);
    },
    //通过onchanne触发方法获得文件列表
    handleChange: function handleChange(file, fileList) {
      if (this.accept) {
        var str = "/.(" + this.accept.replace(/,/g, "?|") + "?" + ")$/i";
        var fileName = file.name.toLowerCase();
        var name = eval(str).test(fileName);
        if (!name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: "支持文件格式：" + "\n" + this.accept,
            type: "warning"
          });
          return false;
        } else {
          this.fileList = fileList;
          this.name = fileList[0].name;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      if (this.accept) {
        var str = "/.(" + this.accept.replace(/,/g, "?|") + "?" + ")$/i";
        var fileName = file.name.toLowerCase();
        var name = eval(str).test(fileName);
        if (!name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: "支持文件格式：" + "\n" + this.accept,
            type: "warning"
          });
          return false;
        }
      }
    },
    submitUpload: function submitUpload() {
      this.$message.error("111");
      this.$refs.upfile.submit();
    }
  }
};